<template>
    <div>
        <froala :tag="'textarea'" :config="config" v-model="currentHtmlText"></froala>
    </div>
</template>

<script>
    import { WYSIWYG_EDITOR_CONFIG } from './../../globalConstants';
    import VueCookies from "vue-cookies";
    
    export default {
        data() {
            return {
                currentHtmlText: '',
                config: {
                    key: 'uXD2lC7F6B4B4A3A3B9dD-13B-11ayiqE2bdD-13C3B2E2D2E3C1A3C7B2B1==',
                    placeholderText: '',
                    charCounterCount: false,
                    imageUploadURL: '/api/upload/image',
                    fileUploadURL: '/api/upload/file',
                    requestHeaders: {
                        Authorization: 'Bearer ' + (VueCookies.get('access_token') || null)
                    },
                }
            }
        },
        props: {
            value: String
        },
        components: {
        },
        watch: {
            currentHtmlText(newVal, oldVal) {
                this.$emit("input", newVal);
            },
            value(newVal, oldVal) {
                this.currentHtmlText = newVal;
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="scss">
    /*.show-html-btn-container {*/
    /*    display: flex;*/
    /*    justify-content: flex-end;*/
    /*    margin-top: 1em;*/
    /*}*/
    /*.raw-html-editor {*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*}*/
    /*.btn-secondary:active::v-deep, .btn-secondary:focus::v-deep {*/
    /*    color: black !important;*/
    /*}*/
    
    .fr-toolbar {
        border-radius: 0px !important;
    }
    
    .second-toolbar {
        border-radius: 0px !important;
    }
    
    #fr-logo {
        display: none
    }
</style>
